import {useSyncExternalStore} from 'react'

export type MonaFooterLayout = 'desktop' | 'tablet' | 'mobile'

const GRID_MEDIA_QUERIES = {
  tablet: '(max-width: 833px)',
  mobile: '(max-width: 439px)',
}

function subscribeGridLayout(onChange: () => void) {
  const queries = Object.values(GRID_MEDIA_QUERIES).map(query => window.matchMedia(query))
  for (const query of queries) query.addEventListener('change', onChange)
  return () => {
    for (const query of queries) query.removeEventListener('change', onChange)
  }
}

export function getMonaFooterLayoutSnapshot(): MonaFooterLayout {
  if (window.matchMedia(GRID_MEDIA_QUERIES.mobile).matches) return 'mobile'
  if (window.matchMedia(GRID_MEDIA_QUERIES.tablet).matches) return 'tablet'
  return 'desktop'
}

function getGridLayoutServerSnapshot(): MonaFooterLayout {
  return 'desktop'
}

export function useMonaFooterLayout() {
  return useSyncExternalStore(subscribeGridLayout, getMonaFooterLayoutSnapshot, getGridLayoutServerSnapshot)
}
